/**
 * Copyright (c) HashiCorp, Inc.
 */

import { array } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import { join, union } from '@nullvoxpopuli/ember-composable-helpers';

import CutTextWithIcon from '../text-with-icon.gts';

import type { TOC } from '@ember/component/template-only';

export interface MetadataTagsSignature {
  Args: {
    tags?: string[];
  };
  Element: HTMLDivElement;
}

const MetadataTags: TOC<MetadataTagsSignature> = <template>
  {{#if @tags}}
    <CutTextWithIcon
      @icon="tag"
      @text={{join ", " (union (or @tags (array)))}}
      data-test-tags
    />
  {{/if}}
</template>;

export default MetadataTags;
